mainHandler = {
    $closeBanner          : $('[href=#close-banner]'),
    $shipToDiffAddress    : $('#ship-to-different-address-checkbox'), 
    $bannerContainer      : $('.banner-container'),
    $videoContainer       : $('.video-container'),
    $carouselContainer    : $('.carousel-container'),
    $carouselContainerNav : $('.carousel-container-nav'),
    $carouselContainerMain: $('.carousel-container-main'),
    $triggNav             : $('.trigger-nav'),
    $headerContainer      : $('.header-container'),
    $revealCustom         : $('.reveal-custom'),
    $revealImage          : $('.reveal-image'),
    $itemNav              : $('.item-nav'),
    $bgHalf               : $('.bg-half'),
    $wcCellRightContainer : $('.wc-cell-right-container'),
    $panelAnimate         : $('.panel-animate'),
    $customMagellan       : $('.custom-magellan'),
    $main                 : $('main'),
    $footer               : $('footer'),
    $body                 : $('body'),
    $header               : $('header'),
    $thumbnailColl        : $('.thumb-coll'),
    $heroThumbColl        : $('.hero-thumbnail-container'),
    $singleColl           : $('.single-collection'),
    $pagePrepare          : $('.preparing-page'),

    customMagellan: function(){
        var self = this;
        var screenTop = $(document).scrollTop();

        if (self.$customMagellan.length > 0) {
            var navFound = false;
            self.$customMagellan.find('[data-magellan-target]').each(function() {
                var contentTop    = $(this).offset().top - 50;
                var contentHeight = $(this).outerHeight();
                var id            = $(this).prop('id');
                var $internalNav  = self.$customMagellan.find('.internal-nav-container');
                
                if (self.$singleColl.length > 0) $internalNav = self.$singleColl.find('header .internal-nav-container');

                var $menuActive   = $internalNav.find('[href*="#'+id+'"]');
                var headHeight    = self.$header.outerHeight();

                //if ($(this).hasClass('collection-series')) contentTop = contentTop - (self.$main.find('.rug-head .sticky-container .sticky').innerHeight() + headHeight);
                if ($(this).hasClass('first-series')) contentTop = contentTop - self.$main.find('.rug-head').innerHeight();
                if (self.$singleColl.length > 0) contentTop = contentTop - (self.$singleColl.find('header .series-head').innerHeight()) - 50;

                if (self.$singleColl.length > 0 && self.$header.hasClass('has-series')) {
                    var firstSeriesTop = self.$customMagellan.find('[data-magellan-target].first-series').offset().top - (self.$main.find('.rug-head').innerHeight() + 100);
                    var newTop = screenTop + self.$singleColl.find('header').innerHeight();
                    
                    if (newTop < firstSeriesTop && self.$header.hasClass('series-showing')) self.$header.removeClass('series-showing');
                    else if (newTop > firstSeriesTop && !self.$header.hasClass('series-showing')) self.$header.addClass('series-showing');
                }

                if ((screenTop > contentTop) && (screenTop < (contentHeight + contentTop))) {
                    if (!$menuActive.hasClass('active')) {
                        $internalNav.find('a').removeClass('active');
                        $menuActive.addClass('active');
                    }
                    navFound = true;
                }
            })

            if (self.$singleColl.length > 0 && !navFound) self.$singleColl.find('header .internal-nav-container a').removeClass('active');;
        } 
    },
    
    homepageEvents: function(){
        let self = this;
        
        document.documentElement.style.setProperty('--banner-size', self.$bannerContainer.outerHeight()+'px');
        document.documentElement.style.setProperty('--banner-translate', '-'+self.$bannerContainer.outerHeight()+'px');
        
        this.$closeBanner.on('click',  function(e){
            e.preventDefault();
            document.documentElement.style.setProperty('--banner-translate', '0px');
            self.$bannerContainer.addClass('closed');
            setTimeout(() => {
                self.headerSettings();    
            }, 400);
        });

        this.$videoContainer.on('click',  function(e){
            let $video = $(this).find('video').get(0);
            
            if (!$(this).hasClass('played')) {
                $(this).removeClass('icon-play');
                $(this).addClass('played icon-pause');
                $video.play()
            } else {
                $(this).removeClass('played icon-pause');
                $(this).addClass('icon-play');
                $video.pause()
            }            
        });

        if (self.$panelAnimate && ($('.page-template-page-home').length > 0 )) {

            document.documentElement.style.setProperty('--animate-text-position', ($(window).width() - self.$panelAnimate.children().width())/2+'px');

            //$('#animate-container').imagesLoaded().done( function( instance ) {
                $(window).scrollTop(0);
                //console.log('all images successfully loaded');
                //if ( localStorage['skip-aminate'] !== '1' ) {
                    self.$panelAnimate.addClass('initial-phase');
 
                    setTimeout(() => {
                        self.$panelAnimate.addClass('phase-alt');
                        //self.$panelAnimate.addClass('phase-1');
                        // setTimeout(() => {
                        //     self.$panelAnimate.addClass('phase-2'); 
                                setTimeout(() => { 
                                    let tl = gsap.timeline({
                                        scrollTrigger: {
                                            trigger: ".panel-animate",
                                            start: "top top",
                                            end: "bottom bottom",
                                            scrub: true,
                                            markers: false,
                                            onUpdate: function(e){
                                                if (e.progress > 0.99) {
                                                    e.disable(false, true);
                                                    self.$panelAnimate.addClass('phase-4');
                                                    setTimeout(() => {
                                                        self.$body.removeClass('is-front-page');
                                                        self.$panelAnimate.addClass('phase-5');
                                                        self.$panelAnimate.fadeOut(600);
                                                        setTimeout(() => {
                                                            $(window).scrollTop(0);
                                                        }, 400);
                                                        //localStorage['skip-aminate'] = '1'; 
                                                    }, 2000);
                                                }
                                            }
                                        }
                                    });

                                    if (Foundation.MediaQuery.atLeast('large')) { 
                                        tl.to("#rug-0", { 
                                            yPercent: -130,
                                            xPercent: -200
                                        }, 0)
                                        .to("#rug-1", { 
                                            yPercent: -48,
                                            xPercent: -35
                                        }, 0)
                                        .to("#rug-2", { 
                                            yPercent: 30,
                                            xPercent: -265
                                        }, 0)
                                        .to("#rug-3", { 
                                            yPercent: -40,
                                            xPercent: -53
                                        }, 0)
                                        .to("#rug-4", { 
                                            yPercent:  -70, 
                                            xPercent:  120
                                        }, 0)
                                        .to("#rug-5", { 
                                            yPercent:  62, 
                                            xPercent:  5
                                        }, 0);
                                    } else {
                                        tl.to("#rug-0", { 
                                            yPercent: -145,
                                            xPercent: 15
                                        }, 0)
                                        .to("#rug-1", { 
                                            yPercent: 3,
                                            xPercent: 6
                                        }, 0)
                                        .to("#rug-2", { 
                                            yPercent: -8,
                                            xPercent: -90
                                        }, 0)
                                        .to("#rug-3", { 
                                            yPercent: 130,
                                            xPercent: -155
                                        }, 0)
                                        .to("#rug-4", { 
                                            yPercent:  -16, 
                                            xPercent:  -40
                                        }, 0);
                                        // .to("#rug-5", { 
                                        //     yPercent:  62, 
                                        //     xPercent:  5
                                        // }, 0)
                                    }
                                }, 500); 
                            /*
                            setTimeout(() => {
                                self.$panelAnimate.addClass('phase-3');
                             
                                setTimeout(() => {
                                    self.$panelAnimate.addClass('phase-4');
                                    setTimeout(() => {
                                        self.$body.removeClass('is-front-page');
                                        self.$panelAnimate.fadeOut(500);
                                        localStorage['skip-aminate'] = '1'; 
                                    }, 2000);
                                }, 700);
                            }, 800);
                            */
                       // }, 1200);
                    }, 1300);
                // } else {
                //     self.$body.removeClass('is-front-page');
                //     self.$panelAnimate.addClass('hide');
                // }

         //   });  
        }
    },

    carousel: function(){
        let self = this;
        
        this.$carouselContainer.each(function(){
            let $slider             = null;
            let options             = {};
            let cellLength          = $(this).find('.cell-carousel').length;
            let isCellHero          = $(this).closest('.cell-hero').length > 0;
            let isImgLoad           = $(this).hasClass('is-img-load');
            let isAdapt             = $(this).hasClass('is-adaptive');
            let isFade              = $(this).hasClass('is-fadding');
            let disDrag             = $(this).hasClass('is-disable-drag');
            let hasSelectedImg      = $(this).hasClass('has-selected-image');

            if ($(this).data('is-initialized') == true) {
                $(this).flickity('destroy');
            }
            
            options = {
                cellSelector: '.cell-carousel',
                cellAlign: 'left',
                pageDots: false,
                wrapAround: false,
                prevNextButtons: true,
                draggable: false,
                freeScroll: false,
                imagesLoaded: isImgLoad,
                adaptiveHeight: isAdapt,
                fade: isFade,
                arrowShape: 'M 44 0 L 50.4 6.4 L 18.4 36 H 102.4 V 44.8 H 18.4 L 50.4 74.4 L 44 80.8 L 0 40.8 Z'
            };

            if ((Foundation.MediaQuery.only("small") && (cellLength > 1)) || ((isCellHero && (cellLength > 3)))) {
                options.draggable = true;
            } 

            if (Foundation.MediaQuery.atLeast("medium") && isCellHero && (cellLength < 4)) {
                options.draggable = false;
                options.prevNextButtons = false;
            }

            if (disDrag === true) {
                options.draggable = false;
                options.fade = true;
            }

            $slider = $(this).flickity(options);
            $(this).data('is-initialized', true);
            setTimeout(() => {
                $slider.flickity('resize');
            }, 1000);

            $slider.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
                //if (Foundation.MediaQuery.atLeast("medium")) {
                    $(cellElement).find('.btn-selected-image').click();

                    var index = $(cellElement).find('.selected-image').data('idx');
                    setTimeout(() => {
                        $('.item-nav[data-idx='+index+']').click();
                    }, 200);
                //}
            });
        })


        if (this.$carouselContainerMain.length > 0) {
            let disDrag    = this.$carouselContainerMain.hasClass('is-disable-drag');

            let options = {
                cellSelector: '.cell-carousel',
                cellAlign: 'left',
                contain: true,
                pageDots: false,
            }

            if (disDrag === true/*  && Foundation.MediaQuery.is("small only") */) {
                options.draggable = false;
                //options.fade = true;
            }

            let $main = self.$carouselContainerMain.flickity(options);

            
            $main.on( 'select.flickity', function( event, index ) {
                if (self.$revealImage.hasClass('rev-open')) {
                    self.$carouselContainerMain.css('opacity', 0);
                    self.$carouselContainerMain.find('.cell-carousel').find('.zoomImg').css('opacity', 0);

                    setTimeout(function() {
                        self.$revealImage.removeClass('rev-open');
                        self.$carouselContainerMain.css('opacity', 1);
                    }, 350);
                }
            });

            $(document).on( 'click', '.item-nav', function() {
                var index = $(this).data('idx');
                self.$itemNav.removeClass('active');
                $(this).addClass('active');
                $main.flickity( 'select', index );
            });

            
            if (self.$revealImage.length > 0) {
                self.$revealImage.each(function() {
                    $(this).on('open.zf.reveal', function(e) {
                        $(this).addClass('rev-open');
                    });

                    $(this).on('closed.zf.reveal', function(e) {
                        $(this).removeClass('rev-open');
                    });
                });
            }

            $(document).on('open.zf.reveal', '[data-reveal]', function() {
                $main.flickity('resize');
            });

        }
          
    },

    externalLinkCheck: function() {
        $('a').each(function() {
            var href = this.hostname;

            if (href != window.location.host) {
                $(this).attr('target', '_new');
            }

        });
    },

    headroomInit: function(){
        var self = this;
        var $header    = document.querySelector("header");
        var options = {
            offset: 50,
            tolerance : {
                up : 5,
                down : 0
            },
        }

        if (self.$singleColl.length > 0) {
            var $colhero      = self.$singleColl.find('.coll-hero');
            var heroHeight = $colhero.innerHeight();
            options.offset = heroHeight - (heroHeight * 0.34);
            var imgHeight  = $colhero.find('.thumbnail-image').outerHeight();
            
            if ($colhero.height() < imgHeight ) {
                $colhero.height(imgHeight)
            }
        }

        var headroom   = new Headroom($header, options);

        headroom.init();
    },

    headerSettings: function(){
        var self = this;
        var mainPadTop = self.$headerContainer.outerHeight();

        if (self.$bannerContainer.length > 0) {
            var bannerHeight = self.$bannerContainer.innerHeight();

            mainPadTop = mainPadTop + bannerHeight;
        }
        
        if (!self.$main.hasClass('no-padding')) {
            self.$main.css('padding-top', mainPadTop);
        }
        if (self.$bgHalf) {
            self.$bgHalf.css('top', mainPadTop);
        }
    },

    smoothScroll: function(e, url, time = 'slow'){
        var self = this;
        if (url[0] == '#') {
            var $item = $(url); 
            var headHeight = self.$header.outerHeight();
            //if ($($item).hasClass('collection-series')) headHeight = headHeight + self.$main.find('.rug-head .sticky-container .sticky').innerHeight();

            if ($item.length > 0) {
                self.scrollto( $item.offset().top - headHeight, time);
            }
        }
    },

    scrollto: function(top, time) {
        $('html, body').animate({
            scrollTop: top
        }, time);  
    },


    wcEvents: function(){
        let self   = this;
        
        if (self.$bgHalf.length > 0) {
            let height = self.$main.children().outerHeight() + self.$footer.outerHeight();//height = self.$main.find('.woocommerce').outerHeight();
            let width  = self.$main.children().width();
            let left   = (self.$bgHalf.parent().outerWidth(true) - self.$bgHalf.parent().innerWidth()) / 2;
            let offsetLeft = self.$bgHalf.parent().offset().left - left;

            if (Foundation.MediaQuery.is("medium down")) {
                height = self.$wcCellRightContainer.outerHeight();
            }

            self.$bgHalf.css({
                'opacity': '1',
                'height' : height+'px',
                'left'   : offsetLeft+'px'
            })
        }
    },

    setGlobalStyle: function() {
        var self = this;

        document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.offsetWidth) + 'px');
        document.documentElement.style.setProperty('--window-height', $(window).height() + 'px');
        document.documentElement.style.setProperty('--header-container', '-'+self.$headerContainer.outerHeight()+'px');
        document.documentElement.style.setProperty('--header-height', self.$headerContainer.outerHeight()+'px');
        document.documentElement.style.setProperty('--header-original-container', '-'+self.$header.outerHeight()+'px');
        
        //if (self.$singleColl.length > 0) document.documentElement.style.setProperty('--series-header', '-'+(self.$headerContainer.outerHeight() + self.$singleColl.find('.series-head').outerHeight(true))+'px');

        var dataColor = self.$main.data('active-color');
        if (!dataColor) dataColor = '#000000';

        var dataFillColor = self.$main.data('fill-active-color');
        if (!dataFillColor && dataColor && dataColor != '#000000') dataFillColor = dataColor;
        else if (dataColor == '#000000') dataFillColor = '#BEA6C1';

        var dataBgColor = self.$main.data('active-bg-color');

        document.documentElement.style.setProperty('--active-color', dataColor);
        document.documentElement.style.setProperty('--fill-active-color', dataFillColor);
        document.documentElement.style.setProperty('--active-bg-color', dataBgColor);

        let $navItemtop = 44;
        if ($('.nav-item').length > 0) {
            $navItemtop = $($('.nav-item').get(0)).offset().top;
        } else {
            $navItemtop = $($('.header-menu.trigger-nav').get(0)).offset().top;
        }

        document.documentElement.style.setProperty('--nav-item-top', $navItemtop+'px');
    },

    thumbCollPositioning: function() {
        var self = this;

        if (self.$singleColl.length > 0) {
            if (self.$thumbnailColl.length > 0) {
                /* if (self.$heroThumbColl.length > 0) {
                    var $heroImg = self.$heroThumbColl.find('.thumbnail-image');
                    $heroImg.on('load', function() {
                        var imgW = this.naturalWidth;
                        var imgH = this.naturalHeight;
                        var imgRatio = imgW / imgH;
                        var heroImgW = $($heroImg).height() * imgRatio;
                
                        console.log(heroImgW);
                
                        self.$thumbnailColl.css('width', heroImgW);
                    });
                
                    if ($heroImg[0].complete) {
                        $heroImg.trigger('load');
                    }
                } */

                self.$thumbnailColl.each(function() {
                    var contWidth = $(this).width() / 2;
                    var labelWidth = $(this).find('.label').width() / 2;
    
                    $(this).find('.label').css({
                        'margin-left': -(labelWidth - contWidth),
                        'opacity': 1
                    });
                });
            }
        }
    },

    customAccordion: function(){
        $('[data-accordion-custom]').each(function(){
            var $button = $(this).find('.accordion-title-custom');
            $button.on('click', function(e){
                e.preventDefault();
                let contentHeight = $(this).next().children().outerHeight();
                
                $(this).closest('.accordion').find('.accordion-content-custom').css({
                    'min-height': '0',
                    'height': '0',
                });

                if (!$(this).parent().hasClass('is-active')) {
                    $(this).closest('.accordion').children().removeClass('is-active');
                    $(this).parent().addClass('is-active');
                    $(this).next().css({
                        'min-height': contentHeight,
                        'height': 'auto',
                    });
                } else {
                    $(this).closest('.accordion').children().removeClass('is-active');
                    $(this).next()
                }
                
            })

        });
    },

    init: function(){
        var self = this;    
        
        self.externalLinkCheck();
        self.homepageEvents();
        self.carousel();
        self.headerSettings();
        //self.thumbCollPositioning();
        self.setGlobalStyle();
        self.headroomInit();
        self.customAccordion();

        setTimeout(function() {
            self.wcEvents();
        }, 200);

        if (self.$singleColl.length > 0) {
            setTimeout(function() {
                self.thumbCollPositioning();
            }, 1500);
        }
        
        var hash = window.location.hash;
        self.smoothScroll('', hash, 'slow');
        
        setTimeout(function() {
            document.documentElement.style.setProperty('--default-panel-half-height', self.$main.children().outerHeight()+self.$footer.outerHeight()+'px');
            self.$pagePrepare.addClass('page-ready');
        }, 400);

        $('a').each(function() {
            var aColor = $(this).css('color');
            if (aColor == 'rgb(190, 166, 193)' && !$(this).hasClass('btn-filter-tab') && !$(this).hasClass('sf-item') && !$(this).hasClass('series-button')) {
                var $aEl = '<span class="color-hover-small">'+$(this).html()+'</span>';
                
                if (!$(this).html().includes('<'))
                    $(this).html($aEl);
            }
        });

        $(document).on('click', 'a', function(e) {
            if (!$(this).hasClass('btn-filter-tab')) {
                self.smoothScroll(e, $(this).attr('href'));
            };
        });

        $(document).on('click', '.accordion-title', function(e) {
            e.stopPropagation(); 
            let $mainAccordion = $($(this).closest('.accordion').get(0));
            let fadeOutOnly = $(this).parent().hasClass('fade-out-only'); 
            let $aContent   = $(this).next(); 
            let $allContent = $mainAccordion.find('.accordion-content'); 
             
            if (fadeOutOnly ) {
                $allContent.removeClass('show');
                if ($(this).parent().hasClass('is-active')) {
                    setTimeout(() => {
                        $allContent.parent().removeClass('item-display');
                        $allContent.removeClass('set-fade');
                        $aContent.parent().addClass('item-display');
                        $aContent.addClass('set-fade');
                    }, 50);
                    //setTimeout(() => {
                        $aContent.addClass('show');
                    //}, 0);
                } else {
                    //$aContent.removeClass('show');
                    setTimeout(() => {
                        $aContent.parent().removeClass('item-display');
                        $aContent.removeClass('set-fade');
                    }, 100);
                }
            } else {
                setTimeout(() => {  
                    $allContent.removeClass('show');
                    if ($(this).parent().hasClass('is-active')) {
                        $aContent.addClass('show');
                    } else {
                        if (!$(this).parent().hasClass('fix-height')) {
                            $aContent.removeClass('show');
                        }
                    }
                }, 100);
            }
        });



        $(window).on('load scroll', function(e) {
            self.customMagellan();
        });

        self.$triggNav.on('click', function() {
            $('html').toggleClass('disable-scroll');
            self.$header.toggleClass('is-show-nav');
        });

        self.$shipToDiffAddress.on('click', function(){
            self.$bgHalf.toggleClass('larger-height');
            self.wcEvents();
            setTimeout(() => {
                self.wcEvents();    
            }, 500);
        })
    
        var winWidth = $(window).width();
        $(window).on('resize', function() {
            if ($(this).width() !== winWidth) {
                winWidth = $(this).width();
                self.setGlobalStyle();
                self.headerSettings();
                self.wcEvents();
                self.thumbCollPositioning();

                if (Foundation.MediaQuery.is("small")) {
                    self.carousel();
                }
            }
        })
        
        let $pnl    = $('.panel-rug.custom-magellan.sticky-container');
        let topPnl  = ($pnl.length > 0) ? $pnl.offset().top : 0;
        if (topPnl > 0) {
            $(window).on('scroll', function(){
                var st = window.pageYOffset || document.documentElement.scrollTop; 

                if (st > topPnl ) {
                    self.$header.addClass('fixed-scroll-sticky');
                } else {
                    self.$header.removeClass('fixed-scroll-sticky');
                }
            })
        }

        if (self.$bannerContainer.length > 0) {
            $(window).on('scroll', function(){
                if ( ($(window).scrollTop() > 10) && ($(window).scrollTop() < 100)) {
                    self.headerSettings();
                } else {
                    setTimeout(() => {
                        self.headerSettings();        
                    }, 1000);
                }          
            })
        }
    }
}